import React from 'react'

// Components
import { Box } from '@mui/material'
import Header from 'components/molecules/Header/Header'
import AssetsTable from './components/AssetsTable/AssetsTable'
import StickyFilters from './components/Filters/StickyFilters/StickyFilters'

// Logic
import { useAssetsReportsLogic } from './AssetsReports.logic'

// Store
import {
  useAssetsReportsStore,
  useAssetsReportsActions,
} from 'store/assetsReports/assetsReports.store'

// Styles
import styles from './AssetsReports.module.scss'

const AssetsReports: React.FC = () => {
  const { mappedAssets, isLoading, isError, originalAssets, handleDownload } =
    useAssetsReportsLogic()

  const { filters, canGoBack, canGoForward } = useAssetsReportsStore()

  const { setFilters, goBack, goForward, resetFilters } =
    useAssetsReportsActions()

  if (isError) {
    return (
      <Box className={styles.container}>
        <Header title="Product Reports" parent="Usage" />
        <Box className={styles.errorContainer}>
          Error loading assets data. Please try again.
        </Box>
      </Box>
    )
  }

  return (
    <Box className={styles.container}>
      <Header title="Product Reports" parent="Usage" />
      <Box className={styles.contentWrapper}>
        <StickyFilters
          filters={filters}
          onFiltersChange={setFilters}
          assets={originalAssets || []}
          goBack={goBack}
          goForward={goForward}
          canGoBack={canGoBack()}
          canGoForward={canGoForward()}
          onReset={resetFilters}
        />
        <AssetsTable
          handleDownload={handleDownload}
          assets={mappedAssets}
          isLoading={isLoading}
        />
      </Box>
    </Box>
  )
}

export default AssetsReports
